import logger from 'loglevel';

logger.setLevel(process.env.VUE_APP_LOG_LEVEL);
logger.info('Log level', process.env.VUE_APP_LOG_LEVEL);

export default logger;
